module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In researching this book, the following news media were extremely helpful: the "), _c('i', [_vm._v("New York Daily News")]), _vm._v(", the "), _c('i', [_vm._v("New York Times")]), _vm._v(", the "), _c('i', [_vm._v("Asbury Park Press")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "http://NJ.Com",
      "target": "_blank"
    }
  }, [_vm._v("NJ.Com")]), _vm._v(", the "), _c('i', [_vm._v("Courier Post")]), _vm._v(", the Associated Press, the "), _c('i', [_vm._v("Red Bank Register")]), _vm._v(", the "), _c('i', [_vm._v("Bayonne Times")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "http://Wikipedia.com",
      "target": "_blank"
    }
  }, [_vm._v("Wikipedia.com")]), _vm._v(", the "), _c('i', [_vm._v("Bangor Daily News")]), _vm._v(", TV 34 Freehold News, "), _c('a', {
    attrs: {
      "href": "http://Youtube.com",
      "target": "_blank"
    }
  }, [_vm._v("Youtube.com")]), _vm._v(", the "), _c('i', [_vm._v("Staten Island Advance")]), _vm._v(", the "), _c('i', [_vm._v("Victoria Advocate")]), _vm._v(", the "), _c('i', [_vm._v("Daily Register")]), _vm._v(", the "), _c('i', [_vm._v("Reading Eagle")]), _vm._v(", the "), _c('i', [_vm._v("Herald-Tribune")]), _vm._v(", the "), _c('i', [_vm._v("Express Edition")]), _vm._v(", the "), _c('i', [_vm._v("Daily Mail Edition")]), _vm._v(", the "), _c('i', [_vm._v("Tyrone Daily Herald")]), _vm._v(", the "), _c('i', [_vm._v("Daily Times")]), _vm._v(", the "), _c('i', [_vm._v("Gaveston Daily News")]), _vm._v(", the "), _c('i', [_vm._v("Morning Herald")]), _vm._v(", the "), _c('i', [_vm._v("Wellsville Daily Reporter")]), _vm._v(", the "), _c('i', [_vm._v("Lubbock Evening Journal")]), _vm._v(", the "), _c('i', [_vm._v("Milwaukee Journal")]), _vm._v(", the "), _c('i', [_vm._v("Cumberland Evening Times")]), _vm._v(", Rick Porrello’s American "), _c('a', {
    attrs: {
      "href": "http://Mafia.com",
      "target": "_blank"
    }
  }, [_vm._v("Mafia.com")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "http://dreamindemon.com",
      "target": "_blank"
    }
  }, [_vm._v("dreamindemon.com")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "http://ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("ancestry.com")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "http://philly.com",
      "target": "_blank"
    }
  }, [_vm._v("philly.com")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "http://silive.com",
      "target": "_blank"
    }
  }, [_vm._v("silive.com")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "http://bayonnepd.com",
      "target": "_blank"
    }
  }, [_vm._v("bayonnepd.com")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "http://murderpedia.org",
      "target": "_blank"
    }
  }, [_vm._v("murderpedia.org")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "http://tvbythenumbers.com",
      "target": "_blank"
    }
  }, [_vm._v("tvbythenumbers.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Other resources used were the Bayonne Police Department’s file on the Sladowski Murder, "), _c('i', [_vm._v("State v. Biegenwald")]), _vm._v(" 96 N.J. 630 (1984) 477 A.2d 318, "), _c('i', [_vm._v("State v. Biegenwald")]), _vm._v(" 106 N.J. 13, 524 A 2.d 130 (1987), "), _c('i', [_vm._v("State v. Biegenwald")]), _vm._v(" 126 N.J. 1 (1991) 594 A 2d 172 and "), _c('i', [_vm._v("Biegenwald v. H. Fauver")]), _vm._v(" LW 882.F2d 748, Ronald M. Holmes’s book "), _c('i', [_vm._v("Contemporary Perspectivies on Serial Murder")]), _vm._v(", Colin Evans’s book "), _c('i', [_vm._v("Blood On the Table")]), _vm._v(" and Harry Camisa and Jim Franklin’s book "), _c('i', [_vm._v("Inside Out: Fifty Years Behind the Walls of New Jersey’s Trenton State Prison")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Most important to my research was the time afforded to me by the many people involved in the case. Without their cooperation and patience, this book would not have been possible. Thank you to Bayonne police chief Ralph Scianni, Bayonne police officer Ken Macc, Billy Lucia, Kevin Quinn, Mike Dowling, Bobby Miller, Ken Kennedy, Harry Camisa and Jim Franklin, Guy Spitale, Paul McNicholas and Eric Falks Photography.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Special thanks to James Fagen and Lou Diamond, who spent the most time helping me gain insight into the man one prosecuted and the other defended.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5fb67f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ack.vue
// module id = 69
// module chunks = 0